/**
 * CanvasBarRow — `canvas.bar` renderer. Paints vertical bars
 * keyed on the parent `(number, series)` source's points.
 */
import type { Option } from "../../core/option.ts";
import { Json } from "../../core/json.ts";
import { RendererRow } from "./renderer-row.ts";

/** The `canvas.bar` painter row: draws vertical bars from its parent series source's points. */
export class CanvasBarRow extends RendererRow {
  get seriesKey(): string {
    return Json.string(this.attrs(), "key") ?? "default";
  }

  get color(): Option<string> {
    return Json.string(this.attrs(), "color");
  }

  /** Bar width in the canvas's x-axis units (not pixels). */
  get barWidth(): Option<number> {
    return Json.number(this.attrs(), "barWidth");
  }
}
